import styled from 'styled-components';

import { toCSS } from '../../helpers/styles';

export const DebugDiv = styled.div`
  position: absolute;
  ${() => {
    if (process.env.REACT_APP_ENV === 'production') {
      return `display: none;`;
    } else {
      return `display: none`;
    }
  }}
`;
